import React, { PropsWithChildren, useState } from 'react';

import { css } from '@emotion/react';
import Head from 'next/head';

import * as WordpressHeadGlobal from '../WordpressPorts';
import GlobalStyles from './GlobalStyles';
import Header, { NavLinks } from './Header';
import MenuPanel, { MenuOverlay } from './MenuPanel';

const assetPrefix = 'https://cdn.opendoor.com/fonts';

const GlobalCss = `
@font-face {
  font-family: 'Publico, serif';
  src: url('${assetPrefix}/PublicoHeadline-Bold-Web.eot?#iefix')
      format('embedded-opentype'),
    url('${assetPrefix}/PublicoHeadline-Bold-Web.woff') format('woff'),
    url('${assetPrefix}/PublicoHeadline-Bold-Web.ttf') format('truetype'),
    url('${assetPrefix}/PublicoHeadline-Bold-Web.svg#PublicoHeadline-Bold-Web') format('svg');
  font-weight: 600;
  font-style: bolder;
}
`;

interface PageProps {
  extraNavLinks?: NavLinks;
  hideHeader?: boolean;
  hideHeaderNavLinks?: boolean;
}

const Layout: React.FC<PageProps & PropsWithChildren> = (props) => {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);

  const toggleMenuOpen = () => setMenuOpen(!isMenuOpen);

  return (
    <>
      {WordpressHeadGlobal.Head()}
      <Head>
        <title key="title">Opendoor</title>
        <link
          rel="preload"
          crossOrigin="anonymous"
          href="/fonts/PublicoHeadline-Bold-Web.woff2"
          as="font"
        />
        <style dangerouslySetInnerHTML={{ __html: GlobalCss }} />
      </Head>
      <WordpressHeadGlobal.Page>
        <GlobalStyles />
        <div
          css={css`
            min-height: 100vh;
            margin: 0 auto;
          `}
        >
          <MenuPanel active={isMenuOpen} toggleMenuOpen={toggleMenuOpen} />
          <MenuOverlay onClick={toggleMenuOpen} active={isMenuOpen} />
          {!props.hideHeader && (
            <Header
              isMenuOpen={isMenuOpen}
              toggleMenuOpen={toggleMenuOpen}
              hideHeaderNavLinks={props.hideHeaderNavLinks}
            />
          )}
          {props.children}
        </div>
      </WordpressHeadGlobal.Page>
    </>
  );
};

export default Layout;
